import request from '@/request/Request'

// 班级列表
export function planList(data) {
    return request({
        url: '/api/teach/planList',
        method: 'post',
        params: data
    })
}

// 班级详情
export function planDetail(data) {
    return request({
        url: '/api/teach/planDetail',
        method: 'post',
        params: data
    })
}


// 新增班级
export function addPlan(data) {
    return request({
        url: '/api/teach/createPlan',
        method: 'post',
        data: data
    })
}

// 删除班级
export function delPlan(data) {
    return request({
        url: '/api/teach/delPlan',
        method: 'get',
        params: data
    })
}

// 搜索老师
export function addTeachSearch(data) {
    return request({
        url: '/api/teach/addTeachSearch',
        method: 'get',
        params: data
    })
}

// 添加老师
export function addTeach(data) {
    return request({
        url: '/api/teach/addTeach',
        method: 'post',
        data: data
    })
}


// 手动添加学生
export function handCreateStudent(data) {
    return request({
        url: '/api/teach/handCreateStudent',
        method: 'post',
        data: data
    })
}


// 批量删除学生
export function removeStudent(data) {
    return request({
        url: '/api/teach/removeStudent',
        method: 'post',
        data: data
    })
}

// 批量导入学生
export function importStudent(data) {
    return request({
        url: '/api/teach/importStudent',
        method: 'post',
        data: data
    })
}

// 重置密码
export function resetPassword(data) {
    return request({
        url: '/api/teach/resetPassword',
        method: 'get',
        params: data
    })
}


// 删除任务
export function delTask(data) {
    return request({
        url: '/api/task/delTask',
        method: 'get',
        params: data
    })
}


// 查看学生试卷
export function viewExamDetail(data) {
    return request({
        url: '/api/teach/viewExamDetail',
        method: 'get',
        params: data
    })
}


// 任务顶部统计

export function taskTopStatistics(data) {
    return request({
        url: '/api/task/taskTopStatistics',
        method: 'get',
        params: data
    })
}


// 任务左侧统计
export function taskLeftStatistics(data) {
    return request({
        url: '/api/task/taskLeftStatistics',
        method: 'get',
        params: data
    })
}


// 任务右侧统计
export function taskRightStatistics(data) {
    return request({
        url: '/api/task/taskRightStatistics',
        method: 'get',
        params: data
    })
}


// 任务列表
export function taskList(data) {
    return request({
        url: '/api/task/list',
        method: 'get',
        params: data
    })
}

// 任务详情左侧统计
export function taskDetailLeftStatistics(data) {
    return request({
        url: '/api/task/taskDetailLeftStatistics',
        method: 'get',
        params: data
    })
}


// 任务详情右侧统计
export function taskDetailRightStatistics(data) {
    return request({
        url: '/api/task/taskDetailRightStatistics',
        method: 'get',
        params: data
    })
}

// 任务详情学生列表
export function taskDetailStudent(data) {
    return request({
        url: '/api/task/taskDetailStudent',
        method: 'get',
        params: data
    })
}


// 任务详情
export function taskDetail(data) {
    return request({
        url: '/api/task/taskDetail',
        method: 'get',
        params: data
    })
}

// 学生任务完成情况
export function taskStudentDetail(data) {
    return request({
        url: '/api/task/taskStudentDetail',
        method: 'get',
        params: data
    })
}

// 创建任务获取班级
export function getPlan(data) {
    return request({
        url: '/api/task/getPlan',
        method: 'get',
        params: data
    })
}


// 创建任务
export function createTask(data) {
    return request({
        url: '/api/task/createTask',
        method: 'post',
        data: data
    })
}


// 学生做题详情
export function studentDoTaskDetail(data) {
    return request({
        url: '/api/task/studentDoTaskDetail',
        method: 'get',
        params: data
    })
}



// 阶段考试详情左侧统计
export function stageExamLeftStatistics(data) {
    return request({
        url: '/api/exam/stageExamLeftStatistics',
        method: 'get',
        params: data
    })
}


// 阶段考试详情右侧统计
export function stageExamRightStatistics(data) {
    return request({
        url: '/api/exam/stageExamRightStatistics',
        method: 'get',
        params: data
    })
}


// 阶段考试详情顶部统计
export function stageExamTopStatistics(data) {
    return request({
        url: '/api/exam/stageExamTopStatistics',
        method: 'get',
        params: data
    })
}


// 阶段考试列表
export function stageExamList(data) {
    return request({
        url: '/api/exam/stageExamList',
        method: 'get',
        params: data
    })
}


// 阶段考试详情顶部统计
export function stageExamDetailTopStatistics(data) {
    return request({
        url: '/api/exam/stageExamDetailTop',
        method: 'get',
        params: data
    })
}


// 阶段考试详情左侧统计
export function stageExamDetailLeftStatistics(data) {
    return request({
        url: '/api/exam/stageExamDetailLeft',
        method: 'get',
        params: data
    })
}

// 阶段考试详情中间图表 对比统计
export function stageExamDetailCenterStatistics(data) {
    return request({
        url: '/api/exam/stageExamDetailCenter',
        method: 'get',
        params: data
    })
}

// 阶段考试详情右侧统计
export function stageExamDetailRightStatistics(data) {
    return request({
        url: '/api/exam/stageExamDetailRight',
        method: 'get',
        params: data
    })
}


// 阶段考试详情学生列表
export function stageExamDetailStudent(data) {
    return request({
        url: '/api/exam/stageExamDetailStudent',
        method: 'get',
        params: data
    })
}


// 删除考试
export function delExam(data) {
    return request({
        url: '/api/exam/delExam',
        method: 'get',
        params: data
    })
}


// 发布考试
export function publishExam(data) {
    return request({
        url: '/api/exam/publishExam',
        method: 'get',
        params: data
    })
}



// 消息列表
export function messageList(data) {
    return request({
        url: '/api/message/messageList',
        method: 'get',
        params: data
    })
}

// 标记已读（不再提示）
export function markAsRead(data) {
    return request({
        url: '/api/message/markAsRead',
        method: 'get',
        params: data
    })
}



// 删除已读消息
export function delMarkAsRead(data) {
    return request({
        url: '/api/message/delMarkAsRead',
        method: 'get',
        params: data
    })
}


// 全部标记已读
export function markAsReadAll(data) {
    return request({
        url: '/api/message/markAsReadAll',
        method: 'get',
        params: data
    })
}



// 活动统计
export function activeStatistics(data) {
    return request({
        url: '/api/teach/activeStatistics',
        method: 'get',
        params: data
    })
}


// 用户信息
export function info(data) {
    return request({
        url: '/api/user/info',
        method: 'get',
        params: data
    })
}


// 获取材料列表
export function getArticl(data) {
    return request({
        url: '/api/exam/getArticl',
        method: 'post',
        data: data
    })
}

// 改变文章状态
export function getChangeArticlList(data) {
    return request({
        url: '/api/exam/getChangeArticlList',
        method: 'post',
        data: data
    })
}

// 提交考试设置
export function submitTemExam(data) {
    return request({
        url: '/api/exam/submitTemExam',
        method: 'post',
        data: data
    })
}

// 雅思考试
export function lelts(data) {
    return request({
        url: '/api/exam/lelts',
        method: 'post',
        data: data
    })
}

// 导出任务成绩
export function taskDetailImport(data) {
    return request({
        url: '/api/task/taskDetailImport',
        method: 'post',
        data: data,
        responseType: 'blob' // 关键：设置响应类型为blob，确保文件数据正确处理为二进制格式
    })
}


// 移除老师
export function removeTeach(data) {
    return request({
        url: '/api/teach/removeTeach',
        method: 'post',
        data: data
    })
}



// 雅思考试首页左侧统计
export function ietlsExamLeftStatistics(data) {
    return request({
        url: '/api/exam/ietlsExamLeftStatistics',
        method: 'get',
        params: data
    })
}


// 雅思考试首页右侧统计
export function ietlsExamRightStatistics(data) {
    return request({
        url: '/api/exam/ietlsExamRightStatistics',
        method: 'get',
        params: data
    })
}



// 雅思考试详情左侧统计
export function ieltsExamDetailLeft(data) {
    return request({
        url: '/api/exam/ieltsExamDetailLeft',
        method: 'get',
        params: data
    })
}


// 雅思考试右侧对比图
export function ietlsExamDetailCenter(data) {
    return request({
        url: '/api/exam/ietlsExamDetailCenter',
        method: 'get',
        params: data
    })
}


// 雅思考试详情学生列表
export function ietlsExamDetailStudent(data) {
    return request({
        url: '/api/exam/ietlsExamDetailStudent',
        method: 'get',
        params: data
    })
}


// 雅思考试详情学生试卷
export function ieltsExamStudentPaper(data) {
    return request({
        url: '/api/exam/ieltsExamStudentPaper',
        method: 'get',
        params: data
    })
}
